<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 22">
    <path
      d="M10 8c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4zm0-6c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2zM.51 20.535a3.41 3.41 0 0 1-.26-3.077l2.918-7.726c.57-1.407 2.067-2.08 3.415-1.554l9.802 3.881c.49.195.738.77.555 1.288-.183.517-.73.781-1.218.586l-6.279-2.486-2.302 5.931c-.197.507-.747.757-1.235.546-.483-.21-.714-.795-.515-1.306l2.28-5.873-1.747-.691a.78.78 0 0 0-1.008.443l-2.918 7.726c-.17.418-.132.852.091 1.21.225.36.587.566.994.566h12.97c.524 0 .947.448.947 1 0 .553-.423 1.001-.946 1.001H3.084c-1.04 0-2.002-.548-2.574-1.465z"
      fill="currentColor"
    />
  </svg>
</template>
